<template>
  <div class="filterbar-item" :class="{ 'selected' : isSelected }">
    <b-dropdown :text="text" variant="link" block class="filterbar-item-button" toggle-class="button-no-shadows text-decoration-none">
      <b-dropdown-item v-for="option in optionList" :key="option.key" @click="selectOption(option)" class="list-item">
        {{ option.value }}
      </b-dropdown-item>
    </b-dropdown>
    <font-awesome-icon v-if="isSelected" @click="resetFilter()" icon="fa-solid fa-circle-xmark" class="reset-filter" />
  </div>
</template>
<script>

export default {
  name: "ImportAggregateCosts",
  components: {},
  props: {
    value: {
      type: String,
      default: 'no'
    },
  },
  data () {
    return {
      text: this.$gettext('No grouping'),
      selected: null,
      defaultValue: 'no',
      optionList: [
        { key: 'no', value: this.$gettext("No grouping") },
        { key: 'cost_type', value: this.$gettext("Cost type") },
        { key: 'all', value: this.$gettext("All") },
      ],
    }
  },
  computed: {
    selectedValue () {
      return (this.selected) ? this.selected : this.defaultValue
    },
    isSelected () {
      return (this.selectedValue != this.defaultValue)
    }
  },
  watch: {

  },
  created () {
    this.selected = this.value
    if (!this.value) {
      this.selected = 'no'
    }
    this.text = this.optionList.find(element => element.key === this.selected).value
  },
  methods: {
    selectOption(option) {
      this.selected = option.key
      this.text = option.value
      this.$emit('input', option.key)
    },
    resetFilter () {
      this.selectOption(this.optionList[0])
    }
  }
};
</script>
<style scoped>
</style>